import { render } from "./ClassCreateModal.vue?vue&type=template&id=316ef78e"
import script from "./ClassCreateModal.vue?vue&type=script&lang=js"
export * from "./ClassCreateModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__